import script from "./XPageDataTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./XPageDataTable.vue?vue&type=script&lang=ts&setup=true"

import "./XPageDataTable.vue?vue&type=style&index=0&id=1279e1eb&lang=scss&scoped=true"

import exportComponent from "D:\\x1\\vue3-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1279e1eb"]])

export default __exports__